import { render } from "./PensionPage.vue?vue&type=template&id=fa929322&scoped=true"
import script from "./PensionPage.vue?vue&type=script&lang=js"
export * from "./PensionPage.vue?vue&type=script&lang=js"

import "./PensionPage.vue?vue&type=style&index=0&id=fa929322&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa929322"]])

export default __exports__